import type { FC } from "react";
import React from "react";
import { Desktop, Mobile } from "@edreamsodigeo/frontend-core";

import type { LightBoxFooterButtonsProps } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/contracts";
import { LightboxFooterButtonsDesktop } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/components/LightboxFooterButtonsDesktop";
import { LightboxFooterButtonsMobile } from "~/components/acquisition/Lightbox/LightboxRevamp/components/LightboxFooter/components/LightboxFooterButtonsMobile";

export const LightboxFooterButtons: FC<LightBoxFooterButtonsProps> = ({
  onClose,
  openPrimePage,
}) => (
  <>
    <Desktop>
      <LightboxFooterButtonsDesktop
        onClose={onClose}
        openPrimePage={openPrimePage}
      />
    </Desktop>
    <Mobile>
      <LightboxFooterButtonsMobile
        onClose={onClose}
        openPrimePage={openPrimePage}
      />
    </Mobile>
  </>
);
